/** @format */

import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router";
import QRCode from "../../Shared/Components/QRCode";
import { error } from "../../Shared/Components/Toast";
import { checkLogin } from "../../Shared/hooks/authenticate";
import { frontBaseUrl, resolveMediaUrl } from "../../Shared/utils/helper";

const ShowIDCard = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!checkLogin()) {
      error("برای ادامه ابتدا وارد حساب کاربری خود شوید");
      navigate("/login", { replace: true });
      return;
    }
  }, []);

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    document.onkeydown = (e) => {
      if (
        e.keyCode === 123 ||
        ctrlShiftKey(e, "I") ||
        ctrlShiftKey(e, "J") ||
        ctrlShiftKey(e, "C") ||
        (e.ctrlKey && e.keyCode === "U".charCodeAt(0))
      )
        return false;
    };
  }, []);
  const ctrlShiftKey = (e, keyCode) => {
    return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  };

  const formatFieldValue = (value) => {
    if (value == null || value === "") return "";
    if (typeof value === "object") {
      if (Array.isArray(value)) {
        return value.map(formatFieldValue).filter(Boolean).join(", ");
      }
      return "";
    }
    return String(value);
  };

  const resolveCardPayload = (locationState) => {
    if (!locationState) return null;

    if (locationState.data?.fields != null) {
      return {
        cardData: locationState.data,
        multi: !!locationState.multi,
      };
    }

    if (locationState.fields != null) {
      return {
        cardData: locationState,
        multi: !Array.isArray(locationState.fields),
      };
    }

    return null;
  };

  const cardPayload = resolveCardPayload(state);

  const renderSingleCard = (fieldsArr, props) => {
    const fields = Array.isArray(fieldsArr) ? fieldsArr : [];
    // outer container: no inline-block, no extra margin
    return (
      <div
        className="idcard-item"
        style={{
          width: `${props.width}cm`,
          height: `${props.height}cm`,
          boxSizing: "border-box",
          margin: 0,
          position: "relative",
          overflow: "hidden",
          background: "transparent",
        }}
        key={props.userId ?? Math.random()}
      >
        <img
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: `${props.width}cm`,
            height: `${props.height}cm`,
            objectFit: "cover",
            pointerEvents: "none",
            userSelect: "none",
          }}
          src={resolveMediaUrl(props.background) ?? ""}
          alt=""
        />
        {fields.map((item, idx) =>
          item.name === "avatar" ? (
            <div
              key={idx}
              style={{
                position: "absolute",
                top: item[`top_${item.name}`] + "px",
                right: item[`right_${item.name}`] + "px",
                left: item[`left_${item.name}`] + "px",
                bottom: item[`bottom_${item.name}`] + "px",
                width: (item[`width_${item.name}`] || 0) + "px",
                height: (item[`height_${item.name}`] || 0) + "px",
                overflow: "hidden",
              }}
            >
              <img
                className="font-weight-bold w-100 h-100 selectDisable"
                style={{ objectFit: "cover", pointerEvents: "none" }}
                src={resolveMediaUrl(item.value) ?? ""}
                alt=""
              />
            </div>
          ) : (
            <span
              key={idx}
              className="font-weight-bold selectDisable"
              style={{
                position: "absolute",
                top: item[`top_${item.name}`] + "px",
                right: item[`right_${item.name}`] + "px",
                left: item[`left_${item.name}`] + "px",
                bottom: item[`bottom_${item.name}`] + "px",
                color: "#000",
                fontSize: (props.fontSize || 16) + "px",
                pointerEvents: "none",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {formatFieldValue(item.value)}
            </span>
          )
        )}

        {!_.isEmpty(props.signature) ? (
          <>
            <span
              className="font-weight-bold selectDisable"
              style={{
                position: "absolute",
                top: props.signature?.title_top + "px",
                right: props.signature?.title_right + "px",
                left: props.signature?.title_left + "px",
                bottom: props.signature?.title_bottom + "px",
                color: "#000",
                fontSize: (props.fontSize || 16) + "px",
              }}
            >
              {props.signature?.title ?? ""}
            </span>
            <img
              className="selectDisable"
              src={resolveMediaUrl(props.signature?.image) ?? ""}
              style={{
                width: (props.signature?.width || 0) + "px",
                height: (props.signature?.height || 0) + "px",
                position: "absolute",
                top: props.signature?.image_top + "px",
                right: props.signature?.image_right + "px",
                left: props.signature?.image_left + "px",
                bottom: props.signature?.image_bottom + "px",
              }}
              alt=""
            />
          </>
        ) : null}

        {!_.isEmpty(props.qrCode) ? (
          <div
            className="d-flex position-absolute selectDisable"
            style={{
              top: `${props.qrCode?.top}px`,
              right: `${props.qrCode?.right}px`,
              left: `${props.qrCode?.left}px`,
              bottom: `${props.qrCode?.bottom}px`,
            }}
          >
            <QRCode
              width={
                props.qrCode?.width != undefined ? props.qrCode?.width : 100
              }
              height={
                props.qrCode?.height != undefined ? props.qrCode?.height : 100
              }
              value={`${props.qrCode?.url ?? frontBaseUrl()}/id-card/event/${
                props.eventId
              }/user/${props.userId}`}
            />
          </div>
        ) : null}
      </div>
    );
  };

  const normalizeMulti = (fieldsObj) => {
    if (!fieldsObj) return [];
    return Object.entries(fieldsObj).map(([id, arr]) => ({
      id: Number(id),
      fields: arr,
    }));
  };

  const normalizeSingle = (fieldsArr, userId) => {
    const id = userId ? Number(userId) : null;
    return [{ id, fields: fieldsArr }];
  };

  const chunk = (arr, size) => {
    const res = [];
    for (let i = 0; i < arr.length; i += size) res.push(arr.slice(i, i + size));
    return res;
  };

  return (
    <>
      <style>{`
        @media print {
       
          .no-print { display: none !important; }
          .selectDisable { -webkit-user-select: none; user-select: none; }
          .print-page { page-break-after: always; display: block; width: 100%; }
          .print-page:last-child { page-break-after: auto; }
          .idcard-grid { display: grid; gap: 12px; justify-items: center; align-items: center; }
          .idcard-item { page-break-inside: avoid; break-inside: avoid; }
        }

        /* screen styles */
        .idcard-grid { display: grid; gap: 12px; justify-items: center; align-items: center; }
        .idcard-item { background: transparent; }
      `}</style>

      <div className="row rounded p-2 my-3 overflow-hidden mx-2 selectDisable">
        <div className="col-12 d-flex flex-row justify-content-center align-content-center">
          {!cardPayload?.multi ? (
            <div className="d-flex justify-content-center w-100">
              {cardPayload?.cardData?.fields
                ? renderSingleCard(cardPayload.cardData.fields, {
                    width: cardPayload.cardData?.width || 9,
                    height: cardPayload.cardData?.height || 6,
                    background: cardPayload.cardData?.background_image,
                    fontSize: cardPayload.cardData?.font_size,
                    signature: cardPayload.cardData?.signature || {},
                    qrCode: cardPayload.cardData?.qrCode || {},
                    eventId: cardPayload.cardData?.event_id,
                    userId: cardPayload.cardData?.user_id,
                  })
                : null}
            </div>
          ) : (
            (() => {
              const multiList = normalizeMulti(cardPayload?.cardData?.fields);
              const cardWidth = cardPayload.cardData?.width || 9; // cm
              const cardHeight = cardPayload.cardData?.height || 6; // cm
              const pages = chunk(
                multiList,
                Object.entries(cardPayload?.cardData?.fields)?.length + 1
              );

              return pages.map((page, pIndex) => (
                <div
                  key={pIndex}
                  className="print-page"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px 0",
                    pageBreakAfter:
                      pIndex < pages.length - 1 ? "always" : "auto",
                  }}
                >
                  <div
                    className="idcard-grid"
                    style={{
                      gridTemplateColumns: `repeat(2, ${cardWidth}cm)`,
                      gridTemplateRows: `repeat(2, ${cardHeight}cm)`,
                      gap: "12px",
                      justifyContent: "center",
                      alignContent: "center",
                      width: "100%",
                      maxWidth: `calc(2 * ${cardWidth}cm + 12px + 20mm)`,
                    }}
                  >
                    {page.map((u) =>
                      renderSingleCard(u.fields, {
                        width: cardWidth,
                        height: cardHeight,
                        background: cardPayload.cardData?.background_image,
                        fontSize: cardPayload.cardData?.font_size,
                        signature: cardPayload.cardData?.signature || {},
                        qrCode: cardPayload.cardData?.qrCode || {},
                        eventId: cardPayload.cardData?.event_id,
                        userId: u.id,
                      })
                    )}

                    {/* Fill empty slots so layout stays 2x2 even if less than 4 items */}
                    {page.length < 4 &&
                      Array.from({ length: 4 - page.length }).map((_, i) => (
                        <div
                          key={`empty-${i}`}
                          style={{
                            width: `${cardWidth}cm`,
                            height: `${cardHeight}cm`,
                            boxSizing: "border-box",
                          }}
                        />
                      ))}
                  </div>
                </div>
              ));
            })()
          )}
        </div>

        <div className="col-12 d-flex justify-content-center">
          <button
            onClick={() => {
              window.print();
            }}
            className="btn btn-info w-30 my-5 no-print"
          >
            ذخیره
          </button>
        </div>
      </div>
    </>
  );
};

export default ShowIDCard;
